<template>
  <div class="develop-standard">
    <div class="develop-standard-title">
      <div>项目课程研发标准</div>
    </div>
    <div class="develop-standard-content">
      <div class="develop-common">
        <img src="../pythonImg/1.png" alt="" />
        <h2>"真"项目全套资料保"真"</h2>
        <p>30+测试题库，5+技术拓展专题</p>
      </div>
      <div class="develop-common">
        <img src="../pythonImg/2.png" alt="" />
        <h2>课题内容深入</h2>
        <p>技术解决方案10+</p>
      </div>
      <div class="develop-common">
        <img src="../pythonImg/3.png" alt="" />
        <h2>业务需求还原复现</h2>
        <p>真实复刻企业场景</p>
      </div>
      <div class="develop-common">
        <img src="../pythonImg/4.png" alt="" />
        <h2>业务功能丰富多样</h2>
        <p>功能接口50+</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "developStandard"
}
</script>

<style lang="scss" scoped>
  .develop-standard {
    min-width: 1200px;
    height: 479px;
    margin: 0 auto;
    box-sizing: border-box;
    padding-top: 76px;
    background: #f9faff;
    .develop-standard-title {
      min-width: 1200px;
      margin: 0 auto;
      width: 100%;
      div {
        font-size: 32px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family: "PingFangSC", "PingFangSC-Regular";
        text-align: center;
        color: #19232B;
        font-weight: 600;
        line-height: 47px;
      }
    }
    .develop-standard-content {
      max-width: 1200px;
      display: flex;
      height: 200px;
      margin: 0 auto;
      .develop-common {
        flex: 1;
        margin-top: 76px;
        text-align: center;
        img {
          width: 117px;
          height: 92px;
          display: inline-block;
          text-align: center;
        }
        h2 {
          width: 100%;
          margin-top: 20px;
          text-align: center;
          font-size: 18px;
          font-family:  "PingFangSC", "PingFangSC-Regular";
          text-align: center;
          color: #19232B;
          line-height: 31px;
        }
        p {
          width: 100%;
          margin-top: 6px;
          font-size: 14px;
          font-family:  "PingFangSC", "PingFangSC-Semibold";
          font-weight: 400;
          text-align: center;
          color: #616A72;
          line-height: 25px;
        }
      }
    }
  }
</style>